/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiryResponse as ModelsCustomerCustomerEnquiryResponse } from '../../models/Models/Customer/customer-enquiry-response';

export interface V4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params {
  notificationId: string;
  readStatus: boolean;
}

export function v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json(http: HttpClient, rootUrl: string, params: V4CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json.PATH, 'patch');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
    rb.path('readStatus', params.readStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>;
    })
  );
}

v4CustomersMeNotificationsNotificationIdReadStatusPatch$Json.PATH = '/v4/customers/me/notifications/{notificationId}/{readStatus}';
